function getRowColor(result, greenValues = []) {

  if (result === "") {
    return "#d3d3d3";
  }

  if (
    result === "Matching" ||
    greenValues.includes(result)
  ) {
    return "#BFF4BE";
  }

  return "#FFCCCB";
}

function generateTableRows(data) {
  if (!data || typeof data !== "object") {
    return (
      <tr>
        <td colSpan="2">No data available</td>
      </tr>
    );
  }

  return Object.entries(data).map(([key, value]) => (
    <tr key={key}>
      <th>{key}</th>
      <td>
        {typeof value === "object"
          ? JSON.stringify(value, null, 2)
          : String(value)}
      </td>
    </tr>
  ));
}

function renderInvoiceVsGSTPortal(data) {

  if (!data || Object.keys(data).length === 0) {
    return `
      <tr>
        <td colspan="4">No data available</td>
      </tr>
    `;
  }

  return Object.values(data)
    .map(
      (item) => `
        <tr style="background:${getRowColor(item.Result)}">

          <td>${item.parameter || ""}</td>

          <td>${item.As_per_Invoice || ""}</td>

          <td>
            Trade Name: ${item.As_per_GST_Portal || ""}

            ${
              item.As_per_GST_Portal_legal
                ? `<br><br>Legal Name: ${item.As_per_GST_Portal_legal}`
                : ""
            }
          </td>

          <td>${item.Result || ""}</td>

        </tr>
      `
    )
    .join("");
}

function renderInvoiceValidation(data, greenValues, tooltipKeys) {

  if (!data || Object.keys(data).length === 0) {
    return `
      <tr>
        <td colspan="4">No data available</td>
      </tr>
    `;
  }

  return Object.entries(data)
    .map(([key, item]) => {

      const supportInfo = tooltipKeys.includes(key)
        ? `
          <span title="${item.As_per_Invoice || ""}"
            style="
              text-decoration:underline;
              cursor:pointer;
              color:blue;
            ">
            info
          </span>
        `
        : item.As_per_Invoice || "";

      return `
        <tr style="background:${getRowColor(item.Result, greenValues)}">

          <td>${item.parameter || ""}</td>

          <td>${item.Result || ""}</td>

          <td>${supportInfo}</td>

        </tr>
      `;
    })
    .join("");
}

function renderTwoColumnTable(data, greenValues = []) {

  if (!data || Object.keys(data).length === 0) {
    return `
      <tr>
        <td colspan="2">No data available</td>
      </tr>
    `;
  }

  return Object.values(data)
    .map(
      (item) => `
        <tr style="background:${getRowColor(item.Result, greenValues)}">

          <td>${item.parameter || ""}</td>

          <td>${item.Result || ""}</td>

        </tr>
      `
    )
    .join("");
}

function generateInvoiceHTML(data) {

  const greenValues = data["2b_olive_color"] || [];

  const tooltipKeys = data.keys_with_tooltip || [];

  const renderValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {
      return "-";
    }

    // array
    if (Array.isArray(value)) {
      return value.join(", ");
    }

    // nested object
    if (typeof value === "object") {
      return (
        <table className="inner-table">
          <tbody>
            {Object.entries(value).map(([k, v]) => (
              <tr key={k}>
                <th>{k}</th>
                <td>{renderValue(v)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      );
    }

    return String(value);
  };

  function generateKeyValueRows(obj, emptyMessage = "No data available") {

    if (!obj || Object.keys(obj).length === 0) {
      return `
        <tr>
          <td colspan="2">${emptyMessage}</td>
        </tr>
      `;
    }

    return Object.entries(obj)
      .map(([key, value]) => {

        if (
          typeof value === "object" &&
          value !== null
        ) {
          value = JSON.stringify(value, null, 2);
        }

        return `
          <tr>
            <th>${key}</th>
            <td>${value ?? "-"}</td>
          </tr>
        `;
      })
      .join("");
  }

  return `
  <!DOCTYPE html>

  <html>

  <head>

    <title>Invoice Display</title>

    <style>

      body{
        margin:0;
        font-family: Arial, sans-serif;
        background:#efefef;
      }

      .topbar{
        position:sticky;
        top:0;
        background:#c8b7a9;
        padding:10px;
        text-align:center;
        z-index:999;
        box-shadow:0 2px 5px rgba(0,0,0,0.15);
      }

      .tab-btn{
        background:#0d6efd;
        color:white;
        border:none;
        padding:10px 18px;
        margin:4px;
        border-radius:4px;
        cursor:pointer;
        font-size:15px;
        transition:0.2s;
      }

      .tab-btn:hover{
        opacity:0.9;
      }

      .tab-btn.active{
        background:#11cdef;
      }

      .tab-content{
        display:none;
        padding:20px;
      }

      .tab-content.active{
        display:block;
      }

      table{
        width:70%;
        margin:auto;
        border-collapse:collapse;
        margin-bottom:30px;
        background:white;
        box-shadow:0 2px 8px rgba(0,0,0,0.12);
      }

      th,
      td{
        border:1px solid #d5d5d5;
        padding:10px;
        text-align:left;
        vertical-align:top;
        word-break:break-word;
      }

      th{
        background:#2d2d2d;
        color:white;
      }

      h2,
      h3{
        text-align:center;
        margin-top:25px;
        margin-bottom:15px;
      }

      /* nested object tables */
      .inner-table{
        width:100%;
        margin:0;
        border-collapse:collapse;
        background:#fafafa;
        box-shadow:none;
      }

      .inner-table th,
      .inner-table td{
        border:1px solid #ccc;
        padding:6px;
        font-size:13px;
      }

      .inner-table th{
        background:#f2f2f2;
        color:#222;
        width:35%;
      }

      /* dataframe html tables */
      .dataframe{
        width:100% !important;
        border-collapse:collapse;
      }

      .dataframe th,
      .dataframe td{
        border:1px solid #ccc;
        padding:8px;
      }

      /* mobile responsiveness */
      @media(max-width:900px){

        table{
          width:95%;
        }

        .tab-btn{
          width:90%;
          margin:5px auto;
          display:block;
        }

        th,
        td{
          font-size:13px;
        }
      }
    </style>

  </head>

  <body>

    <div class="topbar">

      <button class="tab-btn active"
        onclick="showTab('invoice-check', this)">
        Invoice Check
      </button>

      <button class="tab-btn"
        onclick="showTab('gst-data', this)">
        Tax Compliance(GST/IT Portal)
      </button>

      <button class="tab-btn"
        onclick="showTab('invoice-grn', this)">
        Invoice vs GRN Data
      </button>

      <button class="tab-btn"
        onclick="showTab('table-data', this)">
        Table Data
      </button>

      <button class="tab-btn"
        onclick="showTab('invoice-data', this)">
        Invoice Data
      </button>

    </div>

    <!-- FIRST TAB -->

    <div id="invoice-check"
      class="tab-content active">

      <h2>Invoice Checks</h2>

      <h3>Table 1: Source - GSTN & Invoice</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>As per Invoice</th>
            <th>As per GST Portal</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${renderInvoiceVsGSTPortal(
            data.Checks?.invoice_vs_gstin_protal
          )}

        </tbody>

      </table>

      <h3>Table 2A: Source - Invoice</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
            <th>Supporting Information</th>
          </tr>

        </thead>

        <tbody>

          ${renderInvoiceValidation(
            data.Checks?.invoice_validations,
            greenValues,
            tooltipKeys
          )}

        </tbody>

      </table>

      <h3>Table 2B: Source - GSTN Data</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${renderTwoColumnTable(
            data.Checks?.gst_portal_check,
            greenValues
          )}

        </tbody>

      </table>

      <h3>Table 2C: Source - Income Tax Data</h3>

      <table>

        <thead>

          <tr>
            <th>Parameters</th>
            <th>Result</th>
          </tr>

        </thead>

        <tbody>

          ${renderTwoColumnTable(
            data.Checks?.income_tax_check,
            greenValues
          )}

        </tbody>

      </table>

    </div>

    <!-- OTHER EMPTY TABS -->

    <div id="gst-data" class="tab-content">

      <h2>Tax Compliance(GST/IT Portal)</h2>

      <h3 class="centered">Customer GST Data</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(
            data.gst_data?.customer_gst_data,
            "No data available , Invalid GST NO or invoice does not have GST NO"
          )}
        </tbody>
      </table>

      <h3 class="centered">Vendor GST Data</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(
            data.gst_data?.vendor_gst_data,
            "No data available , Invalid GST NO or invoice does not have GST NO"
          )}
        </tbody>
      </table>

      <h3 class="centered">Filing Frequency GST Portal</h3>

      <table class="narrow-table">
        <thead>
          <tr>
            <th>Quarter</th>
            <th>Preference</th>
          </tr>
        </thead>

        <tbody>

          ${
            Array.isArray(data.Filinq_frequency) &&
            data.Filinq_frequency.length > 0

              ? data.Filinq_frequency.map(item => `
                  <tr>
                    <td>${item.quarter || "-"}</td>
                    <td>${item.preference || "-"}</td>
                  </tr>
                `).join("")

              : `
                  <tr>
                    <td colspan="2">
                      ${
                        typeof data.Filinq_frequency === "string"
                          ? data.Filinq_frequency
                          : "No data available"
                      }
                    </td>
                  </tr>
                `
          }

        </tbody>
      </table>

      <h2>Filing Status GST Portal</h2>

      <h3 class="centered">GSTR-1 Data</h3>

      <div class="html-table-wrapper">
        ${
          data.df_gstr1_html &&
          data.df_gstr1_html.trim() !== ""
            ? data.df_gstr1_html
            : "<p>No GSTR-1 data available.</p>"
        }
      </div>

      <h3 class="centered">GSTR-3B Data</h3>

      <div class="html-table-wrapper">
        ${
          data.df_3b_html &&
          data.df_3b_html.trim() !== ""
            ? data.df_3b_html
            : "<p>No GSTR-3B data available.</p>"
        }
      </div>

      <h3 class="centered">Pan Details</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(
            data.gst_data?.Pan_Status,
            "No data available , Invalid PAN NO or invoice does not have PAN NO"
          )}
        </tbody>
      </table>

      <h3 class="centered">206AB Compliance</h3>

      <table class="narrow-table">
        <tbody>
          ${generateKeyValueRows(
            data.gst_data?.["206AB_Compliance"],
            "No data available , Invalid PAN NO or invoice does not have PAN NO"
          )}
        </tbody>
      </table>

    </div>

    <div id="invoice-grn" class="tab-content">

      <h2>Table VS GRN</h2>

      <h3>Invoice Table</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${
              Array.isArray(data.grn_vs_invoice?.invoice_data) &&
              data.grn_vs_invoice.invoice_data.length > 0
                ? Object.keys(data.grn_vs_invoice.invoice_data[0] || {})
                    .map(
                      (column) => `
                        <th>${column}</th>
                      `
                    )
                    .join("")
                : `
                  <th>No Columns</th>
                `
            }
          </tr>
        </thead>

        <tbody>
          ${
            Array.isArray(data.grn_vs_invoice?.invoice_data) &&
            data.grn_vs_invoice.invoice_data.length > 0
              ? data.grn_vs_invoice.invoice_data
                  .map(
                    (row) => `
                      <tr>
                        ${
                          row && typeof row === "object"
                            ? Object.values(row)
                                .map(
                                  (value) => `
                                    <td>
                                      ${
                                        typeof value === "object"
                                          ? JSON.stringify(value)
                                          : String(value ?? "")
                                      }
                                    </td>
                                  `
                                )
                                .join("")
                            : `
                              <td colspan="20">Invalid Row</td>
                            `
                        }
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="20">
                    No Data Available
                  </td>
                </tr>
              `
          }
        </tbody>

      </table>

      <h3>GRN Data</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${
              Array.isArray(data.grn_vs_invoice?.grn_data) &&
              data.grn_vs_invoice.grn_data.length > 0
                ? Object.keys(data.grn_vs_invoice.grn_data[0] || {})
                    .map(
                      (column) => `
                        <th>${column}</th>
                      `
                    )
                    .join("")
                : `
                  <th>No Columns</th>
                `
            }
          </tr>
        </thead>

        <tbody>
          ${
            Array.isArray(data.grn_vs_invoice?.grn_data) &&
            data.grn_vs_invoice.grn_data.length > 0
              ? data.grn_vs_invoice.grn_data
                  .map(
                    (row) => `
                      <tr>
                        ${
                          row && typeof row === "object"
                            ? Object.values(row)
                                .map(
                                  (value) => `
                                    <td>
                                      ${
                                        typeof value === "object"
                                          ? JSON.stringify(value)
                                          : String(value ?? "")
                                      }
                                    </td>
                                  `
                                )
                                .join("")
                            : `
                              <td colspan="20">Invalid Row</td>
                            `
                        }
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="20">
                    Invoice Id did not match any OPEN GRN data or no data available against invoice id
                  </td>
                </tr>
              `
          }
        </tbody>

      </table>

      <h3>Invoice VS GRN</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            <th>Particulars</th>
            <th>As per Open GRN Report</th>
            <th>As per Invoice (OCR)</th>
            <th>Result</th>
          </tr>
        </thead>

        <tbody>
          ${
            data.Invoicetable_vs_Grntable_compare &&
            typeof data.Invoicetable_vs_Grntable_compare === "object" &&
            Object.keys(data.Invoicetable_vs_Grntable_compare).length > 0
              ? Object.values(data.Invoicetable_vs_Grntable_compare)
                  .map(
                    (item) => `
                      <tr>
                        <td>${item?.Particulars ?? ""}</td>
                        <td>${item?.As_per_grn ?? ""}</td>
                        <td>${item?.As_per_invoice ?? ""}</td>
                        <td>${item?.result ?? ""}</td>
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="4">
                    No data available
                  </td>
                </tr>
              `
          }
        </tbody>

      </table>

    </div>

    <div id="table-data" class="tab-content">

      <h2>Table Data</h2>

      <h3>Table</h3>

      <table class="narrow-table">

        <thead>
          <tr>
            ${
              Array.isArray(data.table_data?.tabledata_) &&
              data.table_data.tabledata_.length > 0
                ? Object.keys(data.table_data.tabledata_[0] || {})
                    .map(
                      (column) => `
                        <th>${column}</th>
                      `
                    )
                    .join("")
                : `
                  <th>No Columns</th>
                `
            }
          </tr>
        </thead>

        <tbody>
          ${
            Array.isArray(data.table_data?.tabledata_) &&
            data.table_data.tabledata_.length > 0
              ? data.table_data.tabledata_
                  .map(
                    (row) => `
                      <tr>
                        ${
                          row && typeof row === "object"
                            ? Object.values(row)
                                .map(
                                  (value) => `
                                    <td>
                                      ${
                                        typeof value === "object"
                                          ? JSON.stringify(value)
                                          : String(value ?? "")
                                      }
                                    </td>
                                  `
                                )
                                .join("")
                            : `
                              <td colspan="20">Invalid Row</td>
                            `
                        }
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="20">
                    No Data Available
                  </td>
                </tr>
              `
          }
        </tbody>

      </table>

      <h3>Check2</h3>

      <table class="narrow-table">
        <tbody>
          ${
            data.table_data?.check_2 &&
            typeof data.table_data.check_2 === "object" &&
            Object.keys(data.table_data.check_2).length > 0
              ? Object.entries(data.table_data.check_2)
                  .map(
                    ([key, value]) => `
                      <tr>
                        <th>${key}</th>
                        <td>
                          ${
                            typeof value === "object"
                              ? JSON.stringify(value)
                              : String(value ?? "")
                          }
                        </td>
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="2">
                    No Data Available
                  </td>
                </tr>
              `
          }
        </tbody>
      </table>

      <h3>Check3</h3>

      <table class="narrow-table">
        <tbody>
          ${
            data.table_data?.check_3 &&
            typeof data.table_data.check_3 === "object" &&
            Object.keys(data.table_data.check_3).length > 0
              ? Object.entries(data.table_data.check_3)
                  .map(
                    ([key, value]) => `
                      <tr>
                        <th>${key}</th>
                        <td>
                          ${
                            typeof value === "object"
                              ? JSON.stringify(value)
                              : String(value ?? "")
                          }
                        </td>
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="2">
                    No Data Available
                  </td>
                </tr>
              `
          }
        </tbody>
      </table>

    </div>

    <div id="invoice-data" class="tab-content">

      <h2>Invoice Data</h2>

      <table class="narrow-table">

        <tbody>

          ${
            data.invoice_data &&
            Object.keys(data.invoice_data).length > 0
              ? Object.entries(data.invoice_data)
                  .filter(([key]) => {
                    // remove very heavy/unnecessary fields
                    const skipKeys = [
                      "pages",
                      "paragraphs",
                      "tables",
                      "words",
                      "lines",
                      "styles",
                      "selectionMarks",
                      "boundingRegions",
                      "spans",
                      "content",
                      "raw_text",
                    ];

                    return !skipKeys.includes(key);
                  })
                  .map(
                    ([key, value]) => `
                      <tr>
                        <th>${key}</th>

                        <td>

                          ${
                            typeof value === "object" &&
                            value !== null
                              ? `

                                <table class="inner-table">

                                  <thead>
                                    <tr>
                                      <th>Key</th>
                                      <th>Details</th>
                                    </tr>
                                  </thead>

                                  <tbody>

                                    ${Object.entries(value)
                                      .map(
                                        ([subKey, subValue]) => `

                                          <tr>

                                            <td>
                                              ${subKey}
                                            </td>

                                            <td>

                                              ${
                                                typeof subValue === "object"
                                                  ? Object.entries(subValue)
                                                      .map(
                                                        ([k, v]) => `
                                                          <div>
                                                            <strong>${k}</strong> : ${v}
                                                          </div>
                                                        `
                                                      )
                                                      .join("")
                                                  : String(subValue ?? "")
                                              }

                                            </td>

                                          </tr>

                                        `
                                      )
                                      .join("")}

                                  </tbody>

                                </table>

                              `
                              : String(value ?? "")
                          }

                        </td>
                      </tr>
                    `
                  )
                  .join("")
              : `
                <tr>
                  <td colspan="2">
                    No Invoice Data Available
                  </td>
                </tr>
              `
          }

        </tbody>

      </table>

    </div>

    <script>

      function showTab(tabId, button){

        document
          .querySelectorAll(".tab-content")
          .forEach(tab => {
            tab.classList.remove("active");
          });

        document
          .querySelectorAll(".tab-btn")
          .forEach(btn => {
            btn.classList.remove("active");
          });

        document
          .getElementById(tabId)
          .classList.add("active");

        button.classList.add("active");
      }

    </script>

  </body>

  </html>
  `;
}

async function openInvoiceData(responseFile) {
    try {
      const url = `/api/invoice-display/?format=json&response_file=${encodeURIComponent(responseFile)}`;

      const response = await fetch(url, {
        credentials: "include",
      });

      const payload = await response.json();

      if (!payload.success) {
        alert(payload.message || "Unable to load invoice data");
        return;
      }

      const data = payload.data;
      console.log(data);
      
      const newWindow = window.open("", "_blank");

      const html = generateInvoiceHTML(data);

      newWindow.document.open();
      newWindow.document.write(html);
      newWindow.document.close();

    } catch (err) {
      console.error(err);
      alert("Error loading invoice data");
    }
  }



export {
  generateInvoiceHTML,
  openInvoiceData,
  
};